import { getUserIdInToken, storeToken } from 'data/auth/utils'
import { store } from 'duck/store'
import queryString from 'query-string'
import { loginWithEmail } from 'scenes/Account/duck/actions'

export function checkForShadowCorporate() {
  if (!window.location) {
    return
  }
  const { accountToken } = queryString.parse(window.location.search)
  if (!!accountToken && typeof accountToken === 'string') {
    storeToken(accountToken)
    store.dispatch(loginWithEmail.success({ userId: getUserIdInToken() as number, token: accountToken }))
  }
}
